module.exports = __webpack_public_path__ + "img/view3d-notice-light-dhfx2.d4280d56.png";